import request from '@/request'

// 提交反馈申请
export function postFeedback(data) {
  return request({
    url: '/feedback/post',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/feedback.js